import { namedValueCache } from './NamedValueCache';
import { setReachVideoSupport } from './ReachVideos';
import { ActionQueue } from '../../../Utility/ActionQueue';
import { getLedger } from '../../../Cache/ImageCache/ShortCircuit';
import { cachingImageAssetsDebug } from '../../../Cache/ImageCache/FindAndReplaceImages';
import { enableDevMode } from '../../../Utility/Environment';
import { Signage } from '../../../Signage';
import { IPushReceiver } from '../../../MessagingClient/IPushReceiver';
import { pushReceiver } from '../../../MessagingClient/instance';
import { glom } from '../../../Signage/glom';

/**
 * The 'Dev Mode' API, only available if Signage is running in 'Dev Mode'.
 *
 * These functions should only be used for development/debugging.
 */
const dev = {
    actionQueueDebug: ActionQueue.debug,

    cachingImageAssetsDebug: cachingImageAssetsDebug,

    getShortCircuitLedger: getLedger,

    namedValueCache,

    setReachVideoSupport,

    getPushReceiver: async (): Promise<IPushReceiver | undefined> => {
        await Signage.ready();

        return pushReceiver();
    },

    emitEmergencyAlertConfiguration: async (): Promise<void> => {
        await Signage.ready();
        const receiver = pushReceiver();
        if (receiver) {
            receiver.eventEmitter.emitEvent('emergency-alert-feed-update', {
                alertConfigId: glom.alertConfigId,
            });
        } else {
            console.warn('PushReceiver not available to emit emergency-alert-feed-update event');
        }
    },
};

declare global {
    interface Window {
        dev?: typeof dev;
    }
}

/**
 * Enable 'Dev Mode' and populate `window` with its functions.
 */
export function enableDevModeApi(): void {
    enableDevMode();
    window.dev = dev;
}
